import { render, staticRenderFns } from "./DownloadMobileAppModal.vue?vue&type=template&id=56e1c8ed&scoped=true&"
import script from "./DownloadMobileAppModal.vue?vue&type=script&lang=js&"
export * from "./DownloadMobileAppModal.vue?vue&type=script&lang=js&"
import style0 from "./DownloadMobileAppModal.vue?vue&type=style&index=0&id=56e1c8ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e1c8ed",
  null
  
)

export default component.exports